import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'jalali-moment';

@Pipe({
    name: 'jalaliTime'
})
export class JalaliTimePipe implements PipeTransform {

    transform(value: any, args?: any): any {
        if (value) {
            const momentDate = moment(new Date(value));
            return momentDate.format('hh:mm A');
        }
    }
}
